// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3cTbe","title":"BackImages_title__P2eNC","images":"BackImages_images__2Z2YW"};